export const entrepreneurshipConst = {
  path: "/single-programs/entrepreneurship",
  title: "ФАКУЛЬТЕТ ЭКОНОМИКИ И УПРАВЛЕНИЯ – ПРЕДПРИНИМАТЕЛЬСТВО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Предпринимательство — создавай бизнес, который работает</h2>
      <p>
        Эта программа ориентирована на тех, кто хочет запускать и развивать бизнес-проекты, вести стартапы или внедрять инновации в
        существующие компании. Вы получите знания в области экономики, маркетинга, управления, цифровых технологий и правовой среды
        предпринимательства.
      </p>
      <p>Программа сочетает стратегическое мышление, практическую реализацию идей и работу с реальными кейсами.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы предпринимательства и бизнес-моделирования</li>
        <li>Разработка и реализация бизнес-плана</li>
        <li>Финансовое планирование и инвестиции в стартапы</li>
        <li>Маркетинг и поведение потребителей</li>
        <li>Управление проектами и командами</li>
        <li>Юридические аспекты бизнеса и налогообложение</li>
        <li>Цифровая трансформация и e-commerce</li>
        <li>Стратегии масштабирования и выхода на международные рынки</li>
      </ul>
      <p>
        Обучение включает создание собственных проектов, акселерационные сессии, участие в конкурсах стартапов и консультации с менторами из
        бизнеса.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Основатель или сооснователь бизнеса</li>
        <li>Бизнес-девелопер в корпорациях и IT-компаниях</li>
        <li>Менеджер инновационных проектов</li>
        <li>Консультант по развитию бизнеса и запуску стартапов</li>
        <li>Руководитель малого или среднего предприятия</li>
        <li>Продакт-менеджер и стратег в коммерческих структурах</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€45,000 до €90,000 в год</strong> (или без потолка — для владельцев бизнеса)
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с высокой предпринимательской репутацией</li>
        <li>Обучение на русском или английском языке</li>
        <li>Гибкий формат — очно или дистанционно</li>
        <li>Программа с ориентацией на реальный рынок</li>
        <li>Менторство от практиков и основателей бизнеса</li>
        <li>Поддержка стартапов и возможность развивать свой проект в процессе обучения</li>
      </ul>
      <p>Бизнес — это решение проблем через ценность. Мы учим создавать эту ценность с нуля.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия сопровождает вас на каждом этапе — от выбора направления до подачи заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Предпринимательство — создавай бизнес, который работает
    Эта программа ориентирована на тех, кто хочет запускать и развивать бизнес-проекты, вести стартапы или внедрять инновации в существующие компании. Вы получите знания в области экономики, маркетинга, управления, цифровых технологий и правовой среды предпринимательства.
    Программа сочетает стратегическое мышление, практическую реализацию идей и работу с реальными кейсами.
    Что вы будете изучать?
    • Основы предпринимательства и бизнес-моделирования
    • Разработка и реализация бизнес-плана
    • Финансовое планирование и инвестиции в стартапы
    • Маркетинг и поведение потребителей
    • Управление проектами и командами
    • Юридические аспекты бизнеса и налогообложение
    • Цифровая трансформация и e-commerce
    • Стратегии масштабирования и выхода на международные рынки
    Обучение включает создание собственных проектов, акселерационные сессии, участие в конкурсах стартапов и консультации с менторами из бизнеса.
    Кем можно работать после окончания?
    • Основатель или сооснователь бизнеса
    • Бизнес-девелопер в корпорациях и IT-компаниях
    • Менеджер инновационных проектов
    • Консультант по развитию бизнеса и запуску стартапов
    • Руководитель малого или среднего предприятия
    • Продакт-менеджер и стратег в коммерческих структурах
    Зарплата в Европе: от €45,000 до €90,000 в год (или без потолка — для владельцев бизнеса)
    Почему выбирают нас?
    • Европейский диплом с высокой предпринимательской репутацией
    • Обучение на русском или английском языке
    • Гибкий формат — очно или дистанционно
    • Программа с ориентацией на реальный рынок
    • Менторство от практиков и основателей бизнеса
    • Поддержка стартапов и возможность развивать свой проект в процессе обучения
    Бизнес — это решение проблем через ценность. Мы учим создавать эту ценность с нуля.

    Как поступить?
    Приёмная комиссия сопровождает вас на каждом этапе — от выбора направления до подачи заявки.
  `,
};
